import { render, staticRenderFns } from "./BatchModifyDetail.vue?vue&type=template&id=31c7eeb0&scoped=true"
import script from "./BatchModifyDetail.vue?vue&type=script&lang=js"
export * from "./BatchModifyDetail.vue?vue&type=script&lang=js"
import style0 from "./BatchModifyStock.vue?vue&type=style&index=0&id=31c7eeb0&prod&scoped=true&lang=css&external"
import style1 from "./BatchModifyDetail.vue?vue&type=style&index=1&id=31c7eeb0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31c7eeb0",
  null
  
)

export default component.exports